var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.fetching)?_c('div',[_c('FacebookCampaignHeader',_vm._b({},'FacebookCampaignHeader',{ title: _vm.facebookCampaign.name },false)),_c('TabbedMenu'),_c('div',{staticClass:"p-16"},[_c('Transition',{attrs:{"name":"slide-right","mode":"out-in"}},[_c('RouterView')],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }